<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">CDMA - Setup Authentication Group</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
              >&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div>
      <div v-else>
        <b-row>
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
                <div class="primary-table">
                  <b-container class="text-xs text-right">
                    <b-row>
                      <b-col class="text-right">
                        <div class="input-group">
                          <b-input-group>
                            <template #prepend>
                              <base-button size="sm" type="light" disabled>
                                Filter
                              </base-button>
                            </template>
                            <b-form-input
                                id="filter"
                                type="text"
                                v-model="filter"
                                size="sm"
                                placeholder="Search inventory"
                                v-on:keyup.enter="filterQuery"
                            ></b-form-input>
                            <template #append>
                              <base-button
                                  size="sm"
                                  type="primary"
                                  v-on:click="filterQuery"
                              >
                                <i class="fa fa-search"></i>
                              </base-button>
                              <base-button
                                  size="sm"
                                  type="success"
                                  title="Create New Entry"
                                  v-on:click="addRecord"
                                  :hidden="isReadOnly"
                              >
                                <i class="fa fa-plus"></i> New
                              </base-button>
                              <base-button
                                  size="sm"
                                  type="warning"
                                  title="Reload Inventory"
                                  v-on:click="reloadPage"
                              >
                                <i class="fa fa-recycle"></i>
                              </base-button>
                            </template>
                          </b-input-group>
                        </div>
                        <br/>
                      </b-col>
                    </b-row>
                  </b-container>
                  <div class="grey-sideborder">
                    <b-table
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @sort-changed="sortingChanged"
                        :items="listItems"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="0"
                        head-row-variant="primary-table"
                        class="primary-table w-auto"
                        sticky-header="true"
                        show-empty
                        responsive
                        striped
                        hover
                        outlined>
                      <template #empty="scope">
                        <div v-if="isLoading" class="text-center">
                          <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                        </div>
                        <div v-else class="text-center">
                          <b>No inventory found</b>
                        </div>
                      </template>
                      <template v-slot:cell(action)="data">
                        <base-button
                            size="sm"
                            type="info"
                            title="Edit Record"
                            v-on:click="editRecord(data)"
                            :hidden="isReadOnly"
                        >
                          <i class="ni ni-check-bold"></i>
                        </base-button>
                        <base-button
                            size="sm"
                            type="danger"
                            title="Delete Record"
                            v-on:click="deleteRecord(data)"
                            :hidden="isReadOnly"
                        >
                          <i class="fa fa-trash"></i>
                        </base-button>
                      </template>
                    </b-table>
                  </div>
                  <br/>
                  <b-container class="text-xs">
                    <b-row>
                      <b-col class="text-left">{{ resultsFound }}</b-col>
                      <b-col class="text-center">
                        <b-pagination
                            v-if="total"
                            v-model="currentPage"
                            :total-rows="total"
                            :per-page="length"
                        >
                        </b-pagination>
                      </b-col>
                      <b-col class="text-right">{{ resultsUpdated }}</b-col>
                    </b-row>
                  </b-container>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </base-header>

    <b-modal id="addModel" v-model="showAddModal" title="Add a New Record" centered>
      <div class="input-group">
        <b-input-group>
          <template #prepend>
            <base-button size="sm" type="primary" disabled style="width: 150px"> USERNAME</base-button>
          </template>
          <b-form-input type="text" v-model="add_username" :state="add_usernameState"></b-form-input>
        </b-input-group>
      </div>
      &nbsp;
      <div class="input-group">
        <b-input-group>
          <template #prepend>
            <base-button size="sm" type="primary" disabled style="width: 150px"> groupname</base-button>
          </template>
          <b-form-input type="text" v-model="add_groupname" :state="add_groupnameState"></b-form-input>
        </b-input-group>
      </div>
      &nbsp;
      <div class="input-group">
        <b-input-group>
          <template #prepend>
            <base-button size="sm" type="primary" disabled style="width: 150px"> PRIORITY</base-button>
          </template>
          <b-form-input type="number" v-model="add_priority" :state="add_priorityState"></b-form-input>
        </b-input-group>
      </div>
      <template #modal-footer>
        <div>
          <base-button type="light" size="sm" class="float-right" @click="showAddModal = false"
          >Cancel
          </base-button>
        </div>
        <div>
          <base-button
              type="primary"
              size="sm"
              class="float-right"
              @click="addRecordSave()"
              v-if="!recordUpdating"
          >Save
          </base-button>
          <b-button class="btn btn-primary" size="sm" variant="primary" disabled v-if="recordUpdating">
            <b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
            Saving...
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="editModel" v-model="showEditModal" title="Edit an Existing Record" centered>
      <div class="input-group">
        <b-input-group>
          <template #prepend>
            <base-button size="sm" type="primary" disabled style="width: 150px"> USERNAME</base-button>
          </template>
          <b-form-input type="text" v-model="edit_username" :state="edit_usernameState"></b-form-input>
        </b-input-group>
      </div>
      &nbsp;

      <div class="input-group">
        <b-input-group>
          <template #prepend>
            <base-button size="sm" type="primary" disabled style="width: 150px"> groupname</base-button>
          </template>
          <b-form-input type="text" v-model="edit_groupname" :state="edit_groupnameState"></b-form-input>
        </b-input-group>
      </div>
      &nbsp;

      <div class="input-group">
        <b-input-group>
          <template #prepend>
            <base-button size="sm" type="primary" disabled style="width: 150px"> PRIORITY</base-button>
          </template>
          <b-form-input type="number" v-model="edit_priority" :state="edit_priorityState"></b-form-input>
        </b-input-group>
      </div>

      <template #modal-footer>
        <div>
          <base-button type="light" size="sm" class="float-right" @click="showEditModal = false"
          >Cancel
          </base-button>
        </div>
        <div>
          <base-button
              type="primary"
              size="sm"
              class="float-right"
              @click="editRecordSave()"
              v-if="!recordUpdating"
          >Save
          </base-button>
          <b-button class="btn btn-primary" size="sm" variant="primary" disabled v-if="recordUpdating">
            <b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
            Saving...
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="deleteModel" v-model="showDeleteModal" title="Please Confirm" centered>
      <div>
        <span class="text-center">Are you sure you want to delete this entry? [{{ edit_username }}]</span>
      </div>
      <template #modal-footer>
        <div>
          <base-button type="light" size="sm" class="float-right" @click="showDeleteModal = false"
          >Cancel
          </base-button>
        </div>
        <div>
          <base-button
              type="danger"
              size="sm"
              class="float-right"
              @click="deleteRecordSave()"
              v-if="!recordUpdating"
          >Delete
          </base-button>
          <b-button class="btn btn-primary" size="sm" variant="primary" disabled v-if="recordUpdating">
            <b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
            Deleting...
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import cdmaDashboardService from "@/common/api-services/cdma-dashboard-service";
import moment from "moment";
import initService from "@/common/api-services/init-service";
import authService from "@/common/api-services/auth-service";
import ToastVue from "../../Components/Toast.vue";

export default {
  components: {
    RouteBreadCrumb,
    ToastVue
  },

  data() {
    return {
      recordUpdating: false,

      showAddModal: false,
      add_username: "",
      add_groupname: "",
      add_priority: "",

      showDeleteModal: false,
      showEditModal: false,
      edit_username: "",
      edit_groupname: "",
      edit_priority: "",

      lastQuery: "",
      sortBy: "username",
      sortDesc: false,
      start: 0,
      length: 15,
      total: 0,
      sort: "username asc",
      filter: "",
      listItems: [],
      currentPage: 1,
      resultsFound: "",
      resultsUpdated: "",
      isLoading: false,
      fields: [
        {
          key: "id",
          label: "ID",
          thClass: "d-none",
          tdClass: "d-none",
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
          thClass: "bg-primary",
        },
        {
          key: "username",
          label: "User Name",
          sortable: true,
        },
        {
          key: "groupname",
          label: "Group Name",
          sortable: true,
        },
        {
          key: "priority",
          label: "Priority",
          sortable: true,
        },
      ],
      params: "",

      //ACCESS ROLES
      noAccess: true,
      isReadOnly: true,
      isEditor: false,
      isAdministrator: false,
      isPortalAdmin: false,
    };
  },

  computed: {
    add_usernameState() {
      return this.add_username.length > 0 ? true : false;
    },
    add_groupnameState() {
      return this.add_groupname.length > 0 ? true : false;
    },
    add_priorityState() {
      return this.add_priority.length > 0 ? true : false;
    },

    edit_usernameState() {
      return this.edit_username.length > 0 ? true : false;
    },
    edit_groupnameState() {
      return this.edit_groupname.length > 0 ? true : false;
    },
    edit_priorityState() {
      return this.edit_priority.length > 0 ? true : false;
    },
  },

  watch: {
    currentPage: {
      handler: function (value) {
        this.currentPage = value;
        if (!this.sort || this.sort === "") this.sort = "username ASC";
        if (!this.currentPage || this.currentPage === 1) {
          this.start = "0";
          this.total = "0";
        } else {
          this.start = this.currentPage - 1;
        }
        this.loadRecords();
      },
    },
  },

  mounted() {
    document.title = "CDMA - Auth Group";

    /** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
     */

    //The user needs to be notified that this is not accessible.
    this.noAccess =
        !initService.getUserRoles().includes("Administrator") &&
        !initService.getUserRoles().includes("CDMA_ADMIN") &&
        !initService.getUserRoles().includes("CDMA_READ") &&
        !initService.getUserRoles().includes("CDMA_EDIT");

    //set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
    this.isReadOnly =
        initService.getUserRoles().includes("CDMA_READ") &&
        !initService.getUserRoles().includes("Administrator") &&
        !initService.getUserRoles().includes("CDMA_ADMIN");
    this.isEditor = initService.getUserRoles().includes("CDMA_READ");
    this.isAdministrator =
        initService.getUserRoles().includes("Administrator") || initService.getUserRoles().includes("CDMA_ADMIN");
    this.isPortalAdmin = initService.getPortalAdminRole();

    //write to console.
    console.log("PAGE:", document.title);
    console.log("isReadOnly:", this.isReadOnly);
    console.log("isEditor:", this.isEditor);
    console.log("isAdministrator:", this.isAdministrator);
    console.log("isPortalAdmin:", this.isPortalAdmin);

    //don't do anything unless the user has access
    if (!this.noAccess) {
      this.readCache();
      this.loadRecords();
    }
  },

  methods: {

    readCache() {
      //get the last saved filter criteria
      let search = localStorage.getItem(this.$route.name);
      console.log('reading search:', search);
      if (search) {
        search = JSON.parse(search);
        if (search.start && search.start !== '')
          this.start = search.start;
        if (search.length && search.length !== '')
          this.length = search.length;
        if (search.total && search.total !== '')
          this.total = search.total;
        if (search.sort && search.sort !== '')
          this.sort = search.sort;
        if (search.filter && search.filter !== '')
          this.filter = search.filter;
      }
    },

    writeCache() {
      //set to current filter criteria
      let search = {
        start: this.start,
        length: this.length,
        total: this.total,
        sort: this.sort,
        filter: this.filter,
      };
      console.log('writing search:', search);
      localStorage.setItem(this.$route.name, JSON.stringify(search));
    },

    async reloadPage() {
      this.listItems = null;
      await this.loadRecords();
    },

    async filterQuery() {
      this.total = "0";
      this.listItems = null;
      this.currentPage = null;
      await this.loadRecords();
    },

    async sortingChanged(ctx) {
      this.sort = ctx.sortBy + " " + (ctx.sortDesc ? "desc" : "asc");
      if (!this.sort || this.sort === "") this.sort = "username asc";
      this.currentPage = 1;
    },

    async loadRecords() {
      if (this.isLoading) {
        console.log("lastQuery is running...");
        return;
      }
      this.isLoading = true;
      this.writeCache();
      await cdmaDashboardService
          .getradusergroupList(this.start, this.length, this.total, this.sort, this.filter)
          .then(res => {
            //console.log(res);
            this.isLoading = false;
            this.resultsUpdated = "Last Updated: " + moment().format("MM/DD/YYYY hh:mm:ss");
            if (res.data && res.data.hasOwnProperty("message") && res.data.message.hasOwnProperty("result")) {
              this.listItems = res.data.message.result;
              this.total = res.data.message.total;
              this.start = res.data.message.start;
              this.length = res.data.message.length;
              if (this.total > 0) {
                this.resultsFound = this.total + " record(s) found";
              } else {
                this.resultsFound = "0 record(s) found";
              }
            } else {
              if (!res.data || res.data.message.includes("FAIL")) {
                this.resultsFound = "0 record(s) found due to error. Details: " + res.data.message;
              } else {
                this.resultsFound = "0 record(s) found";
              }
            }
          });
      this.isLoading = false;
    },

    async addRecord() {
      this.add_priority = "1";
      this.add_groupname = "homeagent";
      this.showAddModal = true;
    },

    async addRecordSave() {
      this.recordUpdating = true;
      await cdmaDashboardService
          .addradusergroup(this.add_username, this.add_groupname, this.add_priority)
          .then(res => {
            console.log(res);
            if (!res.data || res.data.message.includes("FAIL")) {
              authService.setActivityLog('CDMA:Radusergroup', "Record NOT saved! Details:" + res.data.message, 1);

              this.showToasterMsg("Record not saved! Details:" + res.data.message, false, "danger");
            } else {
              this.showAddModal = false;
              this.add_username = "";
              this.add_groupname = "";
              this.add_priority = "";
              authService.setActivityLog('CDMA:Radusergroup', "Record saved! Details:" + res.data.message, 0);
              this.showToasterMsg("Record saved!");
              this.reloadPage();
            }
          })
          .catch(e => {
            authService.setActivityLog('CDMA:Radusergroup', JSON.stringify(e), 1);
            this.showToasterMsg("Record not saved! Details:" + e.message, false, "danger");
          });
      this.recordUpdating = false;
    },

    async editRecord(data) {
      this.edit_username = data.item.username;
      this.edit_groupname = data.item.groupname;
      this.edit_priority = data.item.priority;
      this.showEditModal = true;
    },

    async editRecordSave() {
      this.recordUpdating = true;
      await cdmaDashboardService
          .updateradusergroup(this.edit_username, this.edit_groupname, this.edit_priority)
          .then(res => {
            console.log(res);
            if (!res.data || res.data.message.includes("FAIL")) {
              this.showToasterMsg("Record not saved! Details:" + res.data.message, false, "danger");
            } else {
              this.showEditModal = false;
              this.edit_username = "";
              this.edit_groupname = "";
              this.edit_priority = "";
              this.showToasterMsg("Record saved!");
              this.reloadPage();
            }
          })
          .catch(e => {
            this.showToasterMsg("Record not saved! Details:" + e.message, false, "danger");
          });
      this.recordUpdating = false;
    },

    async deleteRecord(data) {
      this.edit_username = data.item.username;
      this.showDeleteModal = true;
    },

    async deleteRecordSave() {
      this.recordUpdating = true;
      await cdmaDashboardService
          .deleteradusergroup(this.edit_username)
          .then(res => {
            console.log(res);
            if (!res.data || res.data.message.includes("FAIL")) {
              this.showToasterMsg("Record not deleted! Details:" + res.data.message, false, "danger");
            } else {
              this.edit_username = "";
              this.showDeleteModal = false;
              this.showToasterMsg("Record deleted!");
              this.reloadPage();
            }
          })
          .catch(e => {
            this.showToasterMsg("Record not deleted! Details:" + e.message, false, "danger");
          });
      this.recordUpdating = false;
    },

    // async deleteRecord(data) {
    //   this.$bvModal.msgBoxConfirm('Are you sure you want to delete this entry? ', {
    //     title: 'Please Confirm',
    //     size: 'mm',
    //     buttonSize: 'sm',
    //     okVariant: 'danger',
    //     okTitle: 'YES',
    //     cancelTitle: 'NO',
    //     footerClass: 'p-2',
    //     hideHeaderClose: false,
    //     centered: true
    //   })
    //     .then((value) => {
    //       if (value) {
    //         cdmaDashboardService.deleteradusergroup(data.item.username).then(res => {
    //           console.log(res);
    //
    //           if (!res.data || res.data.message.includes('FAIL')) {
    //             this.showToasterMsg('Record not deleted!',false,'danger');
    //           } else {
    //             this.showToasterMsg('Record deleted!');
    //             this.reloadPage();
    //           }
    //         }).catch(error => {
    //           this.showToasterMsg('Record not deleted!',false,'danger');
    //         });
    //       }
    //     })
    // },

    showToasterMsg(message, append = false, variant = "success") {
      this.$toast(
          {
            component: ToastVue,
            props: {
              description: message
            }
          },
          {
            type: variant
          })
    },
  },
};
</script>

<style scoped>
.table thead th {
  background-color: #f1f1f1 !important;
}

.table tbody td {
  border-bottom: 1px solid #c0e0e8 !important;
}

.table thead th {
  background-color: #5e72e4 !important;
  color: white !important;
  background-image: none !important;
  border-spacing: 0px !important;
  border-right: 1px solid #5e72e4 !important;
}

.table tbody td {
  background-color: white !important;
  color: black !important;
  background-image: none !important;
  border-bottom: 1px solid #aaaaaa !important;
}
</style>
